import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './ducks';
import axios from 'axios';

axios.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401) {
    localStorage.removeItem('user_token');
    window.location.reload();
  }

  return Promise.reject(error.message);
});

export const store = createStore(
  rootReducer,
  applyMiddleware(
    thunkMiddleware
  )
);
